/**
 * Cart products functionality for handling quantity changes and item removal
 */
class CartProductsComponent {
  constructor() {
    this.form = document.getElementById('cart-form');
    this.cartItems = document.querySelectorAll('[data-cart-item]');

    if (this.form) {
      this.init();
    }
  }

  init() {
    // Handle quantity change buttons
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-quantity-change]');
      if (button) {
        e.preventDefault();
        this.handleQuantityChange(button);
      }

      const removeButton = e.target.closest('[data-remove-item]');
      if (removeButton) {
        e.preventDefault();
        this.handleRemoveItem(removeButton);
      }
    });

    // Handle direct input changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('.quantity-selector__input')) {
        this.handleQuantityInputChange(e.target);
      }
    });
  }

  handleQuantityChange(button) {
    const change = parseInt(button.getAttribute('data-quantity-change'));
    const index = button.getAttribute('data-index');
    const input = document.querySelector(`input[name="updates[]"][data-index="${index}"]`);

    if (input) {
      const currentValue = parseInt(input.value);
      const newValue = Math.max(0, currentValue + change);
      input.value = newValue;

      // Update cart
      this.updateCart(index, newValue);
    }
  }

  handleQuantityInputChange(input) {
    const index = input.getAttribute('data-index');
    const value = Math.max(0, parseInt(input.value) || 0);
    input.value = value;

    // Update cart
    this.updateCart(index, value);
  }

  handleRemoveItem(button) {
    const index = button.getAttribute('data-index');
    this.updateCart(index, 0);
  }

  async updateCart(index, quantity) {
    const formData = new FormData();

    // Get all current quantities
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    inputs.forEach((input, i) => {
      const inputIndex = input.getAttribute('data-index');
      if (inputIndex === index) {
        formData.append('updates[]', quantity);
      } else {
        formData.append('updates[]', input.value);
      }
    });

    try {
      const response = await fetch('/cart/update', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Reload the page to reflect changes
        window.location.reload();
      } else {
        console.error('Cart update failed');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CartProductsComponent();
});

export default CartProductsComponent;